import { Descriptions } from 'antd';
import { useMeterContext } from 'contexts/Meter';
import { VFC } from 'react';
import { useMeterHardwareItems } from 'hooks/useMeterHardwares';
import { FormattedMessage } from 'react-intl';
import { DETAIL_DESCRIPTION_CONFIG } from '../const';
import { MeterHardwares as messages } from '../messages';

export const MeterHardwares: VFC = () => {
  const { inventoryMeter } = useMeterContext();
  const { data: meterHardwareItems } = useMeterHardwareItems({ inventoryMeter: inventoryMeter?.id });

  return (
    <Descriptions bordered={false} column={DETAIL_DESCRIPTION_CONFIG}>
      {meterHardwareItems?.hardwareItems.data
        .filter(meterHardware => meterHardware.deactivated_at === null)
        .map(meterHardware => (
          <Descriptions.Item key={meterHardware.id} label={meterHardware.hardware?.name}>
            <FormattedMessage {...messages.serialNumber} values={{ serialNumber: meterHardware.serial_number }} />
          </Descriptions.Item>
        ))}
    </Descriptions>
  );
};
